import {
  FirebaseActivityRepository,
  FirebaseChecklistRepository,
  FirebaseEventRepository,
  FirebaseMediaRepository,
  FirebaseParticipantRepository,
  FirebasePartnerLogRepository,
  FirebasePartnerRepository,
  FirebasePosterRepository,
  FirebasePublicAgendaRepository,
} from '@nx/infrastructure';
import { auth, db, storage } from './firebase';

export const eventRepository = new FirebaseEventRepository(db);
export const activityRepository = new FirebaseActivityRepository(db);
export const participantRepository = new FirebaseParticipantRepository(db);
export const partnerRepository = new FirebasePartnerRepository(db);
export const partnerLogRepository = new FirebasePartnerLogRepository(db);
export const checklistRepository = new FirebaseChecklistRepository(db);
export const posterRepository = new FirebasePosterRepository(db);
export const publicAgendaRepository = new FirebasePublicAgendaRepository(db);
export const mediaRepository = new FirebaseMediaRepository(storage);

export function getOrganizerId(): string | null {
  return auth.currentUser?.uid ?? null;
}
